import React from "react";
import "./saved.css";
import Navbar from "../../components/navbar/Navbar";
import logo from "../../images/green-logo.png";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Grid from "../../components/grid/Grid";
import GridCourse from "../../components/grid/GridCourse";
import Footer from "../../components/footer/Footer";
import FooterMob from "../../components/footer/FooterMob";
import { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { IoMdRemove } from "react-icons/io";
import Guide from "../../components/guide/Guide";
import VacancyGrid from "../../components/grid/VacancyGrid";
import { baseLocal, baseUrl } from "../../context/BaseUrl";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Saved = () => {
  const val0 = localStorage.getItem("user");
  const userHere = JSON.parse(val0);
  const token = userHere.token;
  console.log(userHere);

  const { id } = useParams();
  const [institute, setInstitute] = useState(null);
  const [vacancy, setVacancy] = useState(null);
  const [courses, setCourses] = useState(null);
  const [reviews, setReviews] = useState([]);

  async function fetchData() {
    const institute_saved = `${baseLocal}/user/user_rights/getfollow/${id}`;
    const vacancy_saved = `${baseLocal}/user/user_rights/postvacancy/${id}`;
    const course_saved = `${baseLocal}/user/user_rights/getbookmark/${id}`;
    const reviews_saved = `${baseLocal}/user/reviews/${id}`;
    // const response = `http://127.0.0.1:3000/user/user_rights/getbookmark/639ec9a5e77a2cc4cc0b64ee`

    const getvacancy = axios.get(vacancy_saved, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const getinstitute = axios.get(institute_saved, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const getcourse = axios.get(course_saved, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const getreviews = axios.get(reviews_saved, {
      headers: { Authorization: `Bearer ${token}` },
    });

    axios.all([getvacancy, getinstitute, getcourse, getreviews]).then(
      axios.spread((...allData) => {
        const allsaved = allData[0].data;
        setVacancy(() => allData[0].data);
        const allfollowed = allData[1].data;
        setInstitute(() => allData[1].data);

        const allsc = allData[2].data;
        setCourses(() => allData[2].data);

        const allrv = allData[3].data;
        setReviews(() => allData[3].data);
      })
    );
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <ToastContainer />

      <div className="home-background">
        {/* <div className="logged"> */}
        <Navbar logoimg={logo} />
        {/* </div> */}
      </div>
      <div className="saved-page">
        <Tabs
          defaultActiveKey="saved"
          transition={false}
          id="noanim-tab-example"
          className="mb-3"
        >
          <Tab eventKey="saved" title="Saved Institutes">
            <div className="row ">
              {institute !== null ? (
                institute.map((item) => (
                  <div className="col-xl-4  col-sm-6 col-12">
                    <Grid
                      image={item.image}
                      dis={"d-block"}
                      name={item.name}
                      location={item.location}
                      institute_id={item.institute_id}
                      about={item.about}
                      reload={fetchData}
                    />
                  </div>
                ))
              ) : (
                <h1>there is no data</h1>
              )}
            </div>
          </Tab>
          <Tab
            onClick={() => fetchData()}
            eventKey="follow"
            title="Saved Vacancy"
          >
            <div className="row">
              {vacancy !== null ? (
                vacancy.map((item) => (
                  <div className="col-xl-4 col-sm-6 col-12">
                    <VacancyGrid
                      image={item.company_banner}
                      name={item.name}
                      location={item.location}
                      vacancy_id={item._id}
                      about={item.about}
                      reload={fetchData}
                    />
                  </div>
                ))
              ) : (
                <h1>there is no data</h1>
              )}
            </div>
          </Tab>
          <Tab onClick={() => fetchData()} eventKey="sc" title="Saved Courses">
            <div className="row g gap-3">
              {courses !== null ? (
                courses.map((item) => (
                  <div className="col-xl-4  col-sm-6 col-12">
                    <GridCourse
                      id={item._id}
                      dis={"d-block"}
                      detail={item}
                      name={item.course}
                      reload={fetchData}
                    />
                  </div>
                ))
              ) : (
                <h1>there is no data</h1>
              )}
              {/* <div className="col-md-4">
                                <Grid />
                            </div>
                            <div className="col-md-4">
                                <Grid />
                            </div>
                            <div className="col-md-4">
                                <Grid />
                            </div> */}
            </div>
          </Tab>
          <Tab onClick={() => fetchData()} eventKey="rv" title="Reviews">
            <div className="row g gap-3">
              <table className="table-striped shadow">
                <tr className="mb-2 bg-success text-white">
                  <th className="p-2">Institute Name</th>
                  <th className="p-2">Review</th>
                  <th className="p-2">Rating</th>
                </tr>

                {reviews ? reviews.map((item) => (
                  <tr>
                    <td className="p-2">{item.institute_id ? item.institute_id.name : ''}</td>
                    <td className="p-2">{item.desc}</td>
                    <td className="p-2">{item.rating / 2}</td>
                  </tr>
                )): ""}
              </table>
            </div>
          </Tab>
        </Tabs>
      </div>

      <Footer />
      <FooterMob />
    </>
  );
};

export default Saved;
